ç<template>
    <v-container fluid class="container-full-bg-gray">
        <v-row>
            <v-col cols="12">
                <v-card class="elevation-12 rounded-10">
                    <table-list-toolbar
                        :title="title"
                        :actions="getActions"
                        :loading="loadingAction"
                        customClass="rounded-top"
                        :groups="documentListActionGroups"
                        :disabled="selected.length == 0"
                        :show_actions="true"
                        @selected-action="selectedAction"
                        @job-done="jobDone"
                        :job_state="downloadJobState"
                    >
                        <template v-slot:initial_btns>
                            <v-btn name="refrescar" color="primary" icon @click="resetDeletedDocuments()"
                                :loading="loading">
                                <img src="@/assets/documents_refresh.svg" width="32" height="32" />
                            </v-btn>
                          <div>
                            <v-tooltip v-if="userData.available_features['feature_miniatura_ampliada'] && preview_docs && permission.can_write && !is_mobile" top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn class="btn-minus-plus" @click="embedPdfSize('auto','100px')" :color="preview_docs?'secondary':'primary'" icon v-bind="attrs" v-on="on">
                                  <img src="@/assets/zoom_out.svg" width="32" height="32" />
                                </v-btn>
                              </template>
                              <span v-if="preview_docs">Disminuir miniatura</span>
                            </v-tooltip>
                          </div>
                          <div>
                            <v-tooltip v-if="permission.can_write && !is_mobile" top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn @click="preview_docs = !preview_docs; embedPdfSize(300,'auto')" :color="preview_docs?'secondary':'primary'" icon v-bind="attrs" v-on="on">
                                  <img src="@/assets/preview_doc.svg" width="32" height="32" />
                                </v-btn>
                              </template>
                              <span v-if="preview_docs">Ocultar previsualización</span>
                              <span v-else>Previsualizar documentos</span>
                            </v-tooltip>
                          </div>
                          <div>
                            <v-tooltip v-if="userData.available_features['feature_miniatura_ampliada'] && preview_docs && permission.can_write && !is_mobile" top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn class="btn-minus-plus" @click="embedPdfSize(450,600)" :color="preview_docs?'secondary':'primary'" icon v-bind="attrs" v-on="on">
                                  <img src="@/assets/zoom_in.svg" width="32" height="32" />
                                </v-btn>
                              </template>
                              <span v-if="preview_docs">Ampliar miniatura</span>
                            </v-tooltip>
                          </div>
                        </template>
                        <template v-slot:end_btns>
                        </template>
                    </table-list-toolbar>
                    <Browser 
                        v-if="filtersData" 
                        :fab="true" 
                        :filters="documentsListFilters"
                        :searchFunc="genFilters" 
                        :cleanFunc="cleFilters" 
                        :small="true"
                    >
                        <template v-slot:inputs>
                            <v-row>
                                <v-col cols="12">
                                    <div>
                                        <v-text-field autocomplete="off"
                                            :label="filtersData.id.label"
                                            v-model="filtersData.id.value"
                                            v-on:keyup.enter="genFilters"></v-text-field>
                                        <v-select
                                            autocomplete="off"
                                            :label="filtersData.kind.label"
                                            v-model="filtersData.kind.value"
                                            :items="filtersData.kind.values"
                                            item-text="name"
                                            item-value="value"
                                            clearable
                                            v-on:keyup.enter="genFilters"
                                        ></v-select>
                                        <v-text-field autocomplete="off"
                                            :label="filtersData.search__icontains.label"
                                            v-model="filtersData.search__icontains.value"
                                            v-on:keyup.enter="genFilters"></v-text-field>
                                    </div>
                                </v-col>
                            </v-row>
                        </template>
                    </Browser>
                    <v-row class="pa-0 ma-0">
                        <v-col cols="12" class="pa-0 ma-0">
                            <v-checkbox v-if="show_select_all"
                                :label="'Aplicar en las ' + currentDocumentsItemsLength + ' facturas'"
                                class="ma-0 pt-4 pl-4 pb-2 pr-0" v-model="send_filters" :disabled="loadingAction"
                                hide-details>
                            </v-checkbox>
                        </v-col>
                    </v-row>
                    <v-data-table class="elevation-1 hover-bg" show-select v-model="selected" filterable
                        :headers="computed_headers" :items="deletedDocuments" :disable-sort="false"
                        :items-per-page="itemsPerPage" :server-items-length="currentDocumentsItemsLength"
                        :options.sync="documentListOptions" :loading="loading" :footer-props="{
                            'items-per-page-options': [5, 10, 50],
                            'items-per-page-text': 'Facturas por página:',
                        }" 
                        :header-props="{ 'sort-by-text': 'Ordenar por'}" 
                        @item-selected="send_filters = false" @toggle-select-all="send_filters = false"
                        @update:options="changeOptions"
                    >
                        <template v-slot:[`item.signed_url`]="{ item }" style="width: 100px">
                            <embed
                                v-if="!userData.available_features['feature_miniatura_ampliada'] && (userData.available_features['feature_can_do_massive_rotation'] || permission.is_invited) && item.signed_url!=='' && item.excel_line_index===null"
                                :src="item.signed_url + '#page=1&toolbar=0&navpanes=0&scrollbar=0'"
                                type="application/pdf" width="100px" height="auto" />
                          <embed
                              v-if="userData.available_features['feature_miniatura_ampliada'] && (userData.available_features['feature_can_do_massive_rotation'] || permission.is_invited) && item.signed_url!=='' && item.excel_line_index===null"
                              :src="item.signed_url + '#page=1&toolbar=0&navpanes=0&scrollbar=0'"
                              type="application/pdf"
                              :width="embedPdfWidth"
                              :height="embedPdfHeight"
                          />
                        </template>
                        <template v-slot:item.punteado="{ item }">
                            <div v-if="item.punteado">
                                <v-icon color="var(--v-success-base)">mdi-check</v-icon>
                            </div>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import TableListToolbar from '../components/TableListToolbar.vue';
import MessagePopup from '../components/MessagePopup.vue';
import Browser from '../components/Browser.vue';
import ActionSelector from '../components/ActionSelector.vue';
import {jobs} from "@/api";


export default {
    name: 'DeletedDocumentList',
    components: {
        TableListToolbar,
        MessagePopup,
        Browser,
        ActionSelector
    },
    data() {
        return {
            title: 'Facturas Borradas',
            loadingAction: false,
            preview_docs: false,
            send_filters: false,
            JOB_ACTIONS: [],
            JOB_STATES: {
                running: 'running',
                done: 'done'
            },
            REFRESH_DATA_ACTIONS: ['restaurar'],
            async_job_msg: '',
            embedPdfHeight: 300,
            embedPdfWidth: 'auto',
        }
    },
    props: {
        companydb_id: {
            type: [String, Number],
        },
    },
    computed: {
        ...mapGetters({
            deletedDocuments: 'deleted_documents/deletedDocuments',
            currentHeaders: 'documents/currentHeaders',
            loading: 'deleted_documents/loading',
            currentDocumentsItemsLength: 'deleted_documents/currentDocumentsItemsLength',
            is_mobile: 'is_mobile',
            userData: 'me/userData',
            itemsPerPage: 'deleted_documents/itemsPerPage',
            permission: 'permissions/permission',
        }),
        ...mapFields('deleted_documents', [
            'documentListAction', 'selected', 'documentListOptions', 'documentsListFilters','filtersData', 'documentListActionGroups',
        ]),
        ...mapFields(['asyncJobId', 'downloadJobState']),
        getActions() {
            let actions = {};
            for (let i in this.documentListAction) {
                let group = this.documentListAction[i]['group'];
                if (!actions.hasOwnProperty(group)) {
                    actions[group] = [];
                }
                actions[group].push(this.documentListAction[i]);
            }
            Object.keys(actions).forEach(function (key) {
                if (actions[key].length == 0) {
                    delete actions[key];
                }
            });
            return actions;
        },
        computed_headers() {
            let headers = this.currentHeaders.slice();
            if (headers.length) {
                if (this.preview_docs) {
                    if (headers[0]['value'] != 'signed_url') {
                        headers = [{
                            text: "PDF",
                            value: "signed_url",
                            width: 100
                        }].concat(headers);
                    }
                } else {
                    if (headers[0]['value'] == 'signed_url') {
                        headers.shift();
                    }
                }
            }
            return headers;
        },
        show_select_all() {
            let show = false;
            let length_items = this.deletedDocuments.length;
            let length_selected = this.selected.length;
            if (length_items===0){
                return false
            }
            if (length_items == length_selected) {
                show = true;
            }
            return show;
        },
    },
    methods: {
        ...mapActions({
            resetDeletedDocuments: 'deleted_documents/resetDeletedDocuments',
            setItemsPerPage: 'deleted_documents/setItemsPerPage',
            restoreDocuments: 'deleted_documents/restoreDocuments',
            cleanFilters: 'deleted_documents/cleanFilters',
            generateFilters: 'deleted_documents/generateFilters',
            waitForLoggedIn: 'waitForLoggedIn',
            refreshUserData: "me/refreshUserData",
            setMessageModal: 'messageModal/setModal',
            closeMessageModal: 'messageModal/closeModal',
            downloadFile:"documents/downloadFile",
            downloadFiles:"documents/downloadFiles",
            downloadCSV: "documents/downloadCSV",
            downloadCSVOneLine: "documents/downloadCSVOneLine",
            downloadMergedDocuments:'documents/downloadMergedDocuments',
            downloadDocsExcel:'documents/downloadExcel',
        }),
        showMessage(m, icon){
            const modal = {
              text: m,        
              actionConfirmButton: this.closeMessageModal,
            }

            if (icon) {
              modal.icon = icon
            }

            this.setMessageModal(modal)
        },
        checkErrorParams() {
            let err_msg = ""
            return err_msg
        },
        async go() {
            if (this.JOB_ACTIONS.indexOf(this.action.id) < 0) {
                this.asyncJobId = 0;
                this.loadingAction = true;
            }
            let err_msg = this.checkErrorParams();
            if (!err_msg) {
                switch (this.action.id) {
                    case 'restaurar':
                        this.restoreDocuments({
                            send_filters: this.send_filters,
                            docs: this.selected
                        }).then((response) => {
                            if (Object.keys(response.data).includes('ko')) {
                                this.showMessage(response.data['ko']);
                                this.loadingAction = false;
                            } else {
                                this.showMessage('Los Documentos se están restaurando.', 'mdi-information-outline');
                                this.asyncJobId = response.data['AsyncJob'];
                                this.downloadJobState = this.JOB_STATES.running;
                                this.loadingAction = false;
                                this.async_job_msg = 'Cambios realizados con exito.';
                            }
                        }).catch(err => {
                            this.showMessage('Algo ha ido mal');
                            console.error(err);
                            this.loadingAction = false;
                        });
                        break;
                    case 'download_doc':
                      if(this.selected.length!=1 || this.send_filters){
                        let docs_ids = []
                        for (let i in this.selected) {
                          docs_ids.push(this.selected[i].id)
                        }
                        this.downloadFiles({ send_filters: this.send_filters, docs_ids: docs_ids }).then(response => {
                          this.asyncJobId = response.data.AsyncJob;
                          this.documentName = "documentos";
                          this.documentFormat = "zip";
                          this.downloadJobState = this.JOB_STATES.running;
                        })
                      } else {
                        let filename = 'doc_'+this.selected[0].id.toString()
                        if (this.selected[0].original_file_name) {
                          filename += '_'+this.selected[0].original_file_name;
                        }
                        else if (this.selected[0].supplier_name){
                          filename += '_'+this.selected[0].supplier_name.replace(' ','_');
                        }
                        else if(this.selected[0].customer_name){
                          filename += '_'+this.selected[0].customer_name.replace(' ','_');
                        }
                        if (!filename.endsWith('.pdf') && !filename.endsWith('.PDF')) {
                          filename+='.pdf'
                        }
                        //console.log(this.selected[0])
                        this.downloadFile({"signed_url":this.selected[0].signed_url,"filename":filename})
                      }
                      break;
                    case 'download_merged_docs':
                      this.downloadMergedDocuments({send_filters: this.send_filters, docs:this.selected, options:this.documentListOptions}).then(response=>{
                        if (Object.keys(response.data).includes('ko')) {
                          this.showMessage(response.data['ko']);
                          this.loadingAction = false;
                        } else {
                          this.asyncJobId = response.data['AsyncJob'];
                          this.documentName = "documentos";
                          this.documentFormat = "pdf";
                          this.downloadJobState = this.JOB_STATES.running;
                        }
                      }).catch(err=>{
                        this.showMessage('Algo ha ido mal');
                        this.loadingAction = false;
                        console.error(err);
                      });
                      break;
                    case 'download_excel':
                      this.downloadDocsExcel({send_filters: this.send_filters, docs:this.selected, headers:this.currentHeaders, options:this.documentListOptions}).then(response=>{
                        this.asyncJobId = response.data['AsyncJob'];
                        this.documentName = "facturas";
                        this.documentFormat = "xlsx";
                        this.downloadJobState = this.JOB_STATES.running;
                      }).catch(err=>{
                        this.showMessage('Algo ha ido mal')
                        console.error(err)
                      })
                      break;

                }
            }
            else {
                this.showMessage(err_msg);
                this.loadingAction = false;
            }
        },
        selectedAction(actionId) {
            this.action = { id: actionId };
            this.go();
        },
        changeOptions() {
            this.resetDeletedDocuments();
            this.setItemsPerPage(this.documentListOptions['itemsPerPage']);
        },
        async jobDone() {
            if (this.REFRESH_DATA_ACTIONS.includes(this.action.id)) {
                this.resetDeletedDocuments();
                this.send_filters = false;
                this.showMessage(this.async_job_msg, 'mdi-information-outline');
            } else if (this.action.id == 'download_merged_docs') {
              try {
                const resp = await jobs.getJobFile({ id: this.asyncJobId });
                let fileURL = resp.data.url;
                const response = await fetch(fileURL)
                const blob = await response.blob();
                const url = await URL.createObjectURL(blob)
                const a = document.createElement("a");
                a.href = url;
                a.download = this.documentName + "." + this.documentFormat;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
              } catch(err) {
                console.debug(err)
              }
            } else { // else if (['download_doc', 'download_excel'].includes(action.id)) {}
              try {
                this.loadingAction = true;
                const response = await jobs.getJobFile({id: this.asyncJobId});
                let fileURL = response.data.url;
                let fileLink = document.createElement("a");
                fileLink.href = fileURL;
                fileLink.setAttribute("download", this.documentName + "." + this.documentFormat);
                document.body.appendChild(fileLink);
                fileLink.click();
                this.loadingAction = false;
              } catch (err) {
                console.debug(err);
                this.loadingAction = false;
              }
            }
        },
        genFilters() {
            this.generateFilters().then(() => {
                this.page = 1;
                this.resetDeletedDocuments();
            });
        },
        cleFilters() {
            this.cleanFilters().then(() => {
                this.page = 1;
                this.resetDeletedDocuments();
            });
        },
        embedPdfSize(height, width){
          this.embedPdfHeight = height;
          this.embedPdfWidth = width;
          this.refreshData();
        },
    },
    async mounted() {
        await this.waitForLoggedIn();
        await this.refreshUserData();
        await this.resetDeletedDocuments()
    }
}
</script>

<style scoped>
.rounded-10 {    
    border-radius: 10px;
}
.btn-minus-plus{
  width:10px !important;
  height:10px !important;
}
</style>